import { useCallback } from "react";
import { PE_KEYS } from "src/shared/constants/PageEventKeys";
import { PE_TYPE } from "src/shared/constants/PageEventTypes";
import { useAppContext } from "src/shared/context/AppContext";
import { useStorePageEvent } from "src/shared/hooks/useStorePageEvent";
import { isStubhub } from "src/shared/utils/appContextHelper";
import { SUPPORTED_DPI_SETTINGS } from "src/website-apps/responsive/stubhub-home/components/top-subcategories/constants";
import { useLinkToNewTabFeature } from "src/website-apps/shared/hooks/useLinkToNewTabFeature";
import {
  StyledBackgroundImage,
  StyledBackgroundImageNoOverlay,
  StyledCategoryName,
  StyledLink,
  StyledTopSubcategoryCard,
} from "./styled-components";

/**
 * Reusable TopSubcategory Treatment Card - Encapsulates Black & White Image Overlay on Purple Background
 */
export const TopSubcategoryCard = ({ as = "li", id, text, className, url, imageUrl, imageSize }) => {
  const appContext = useAppContext();
  const storePageEvent = useStorePageEvent();
  const handleClick = useCallback(() => {
    storePageEvent(PE_TYPE.CLICK, PE_KEYS.TOP_SUBCATEGORY_CARD_CLICK, `${id}`);
  }, [id, storePageEvent]);
  // TMHomeTopCategoryRedesign (17696) deployed variant — redesign always enabled.
  const redesignEnabled = true;

  const getBackgroundImageUrl = useCallback(
    (catId) =>
      `https://media.stubhubstatic.com/stubhub-product/image/upload/q_10/v1695836341/homepage/category-header-images/top-subcat-${catId}.jpg`,
    [],
  );

  const getBackgroundImageSet = useCallback(
    (catId) =>
      SUPPORTED_DPI_SETTINGS.reduce((result, resKey) => {
        result[resKey] = `https://img.vggcdn.net/img/top_category_images/${resKey}/${catId}.jpeg`;
        return result;
      }, {}),
    [],
  );

  const { openInNewTab, clickWrapper } = useLinkToNewTabFeature(handleClick);

  return (
    <StyledTopSubcategoryCard as={as} className={className} size={imageSize}>
      <StyledLink onClick={clickWrapper} url={url} newTab={openInNewTab}>
        {imageUrl ? (
          <StyledBackgroundImageNoOverlay $backgroundImageUrl={imageUrl} />
        ) : (
          <StyledBackgroundImage
            $backgroundImageUrl={getBackgroundImageUrl(id)}
            $isStubhub={isStubhub(appContext)}
            $renderSimpleOverlay={redesignEnabled}
            $backgroundImageSet={getBackgroundImageSet(id)}
          />
        )}
        <StyledCategoryName>{text}</StyledCategoryName>
      </StyledLink>
    </StyledTopSubcategoryCard>
  );
};
